const sidCSRFTokenFieldName = 'auth0Nonce';
const auth0CSRFTokenPrefix = 'com.auth0.auth';
const namespace = 'login';

/**
 * Object **must** be kept in sync with the corresponding server side components
 * constant here: `app/routes/shared/constants.js`.
 *
 * Mismatches between component names used for local components rendering, will
 * lead to the components not being correctly hydrated client side.
 */
const COMPONENTS = Object.freeze({
  CALLBACK: 'Callback',
  COOKIE_BANNER: 'CookieBanner',
  FOOTER: 'Footer',
  HEADER: 'Header',
  LOGIN_FORM: 'LoginForm',
  NOT_FOUND: 'NotFound',
});

const ENTRYPOINTS = Object.freeze({
  IDENTITY_LOGIN: 'identity-login',
  IDENTITY_LOGIN_CALLBACK: 'identity-login-callback',
  SUBSCRIPTION_SUBSCRIBE: 'subscription-subscribe',
  SUBSCRIPTION_UNSUBSCRIBE: 'subscription-unsubscribe',
  SUBSCRIPTION_FAILED: 'subscription-failed',
});

export {
  sidCSRFTokenFieldName,
  auth0CSRFTokenPrefix,
  COMPONENTS,
  ENTRYPOINTS,
  namespace,
};
